export default __webpack_public_path__ + "assets/images/b4b8908825938d4293b5d1c66fa97820.png";